import classNames from 'classnames';
import { ButtonV2, Preloader } from 'components';
import { listenClick } from 'lib/utils';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';
import './style.scss';

class EditPopup extends Component {
  static propTypes = {
    className: PropTypes.string,
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
    visible: PropTypes.bool,
    loading: PropTypes.bool,
    closeOnOutsideClick: PropTypes.bool,
    suppressKeyboardListener: PropTypes.bool
  };

  static defaultProps = {
    closeOnOutsideClick: true
  };

  container = null;

  componentDidUpdate(prevProps) {
    if (this.props.suppressKeyboardListener) {
      return;
    }

    if (!prevProps.visible && this.props.visible && this.props.closeOnOutsideClick) {
      setTimeout(() => document.addEventListener('click', this.listenClick), 250);
    }

    if (prevProps.visible && !this.props.visible) {
      document.removeEventListener('click', this.listenClick);
      document.removeEventListener('keydown', this.handleKeyDown);
    }

    if (!this.props.closeOnOutsideClick) {
      document.removeEventListener('click', this.listenClick);
    }

    if (!prevProps.visible && this.props.visible) {
      setTimeout(() => document.addEventListener('keydown', this.handleKeyDown), 250);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.listenClick);
    if (!this.props.suppressKeyboardListener) {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }

  @bind
  bindContainer(node) {
    this.container = node;
  }

  @bind
  listenClick(e) {
    listenClick(e, this.container, this.props.onSubmit);
  }

  handleKeyDown = e => {
    if (e.key === 'Escape') {
      e.preventDefault();
      this.props.onCancel();
    } else if (e.key === 'Enter') {
      e.preventDefault();

      setTimeout(() => {
        this.props.onSubmit();
      }, 0);
    }
  };

  render() {
    const { visible, loading, children, onCancel, onSubmit, closeOnOutsideClick } = this.props;
    const className = classNames('edit-popup', this.props.className);

    return (
      <CSSTransition in={visible} timeout={300} classNames="edit-popup-transition" unmountOnExit>
        {() => (
          <div
            ref={this.bindContainer}
            className={className}
            role="dialog"
            aria-modal="true"
            tabIndex={-1}
            onKeyDown={!this.props.closeOnOutsideClick ? this.handleKeyDown : undefined}
          >
            <div className="edit-popup__content">{children}</div>
            <div className="edit-popup__actions">
              <div className="edit-popup__submit">
                {loading ? (
                  <Preloader small className="edit-popup__loading" />
                ) : (
                  <ButtonV2 icon iconName="tick" iconSize={24} onClick={onSubmit} ariaLabel={'Submit'} />
                )}
              </div>
              <div className="edit-popup__cancel">
                <ButtonV2 icon iconName="close-circle" iconSize={24} onClick={onCancel} ariaLabel={'Cancel'} />
              </div>
            </div>
          </div>
        )}
      </CSSTransition>
    );
  }
}

export default EditPopup;
